import React from 'react';

interface Props {
  htmlString: string;
  id?: string;
  style?: React.CSSProperties;
  className?: string;
  element?: 'div' | 'span';
}

const HTMLRenderer = ({
  htmlString,
  className,
  style,
  id,
  element = 'span',
}: Props) => {
  const createMarkup = () => {
    return { __html: htmlString };
  };

  const El = element;

  return (
    <El
      id={id}
      className={className}
      style={style}
      dangerouslySetInnerHTML={createMarkup()}
      suppressHydrationWarning
    />
  );
};

export default HTMLRenderer;
